module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wtm-endorphina.8928e195.png";